var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var PayloadRepository_1;
import { ICacheDataSourceType } from '../../DataSource/CacheDataSource/ICacheDataSource';
import { inject } from '../../Decorators/Inject';
import { injectable } from '../../Decorators/Injectable';
import { CoreConfig } from '../../../CoreConfig';
let PayloadRepository = PayloadRepository_1 = class PayloadRepository {
    static onUpdate(moduleName, value) { }
    static setOnUpdate(fn) {
        PayloadRepository_1.onUpdate = fn;
    }
    constructor(cacheDataSource) {
        this.cacheDataSource = cacheDataSource;
    }
    getDisableFetchConfiguration() {
        var _a;
        return !!((_a = this.getPayload(CoreConfig.moduleName).value) === null || _a === void 0 ? void 0 : _a.disable_fetch_configuration);
    }
    getDisableAutoInit() {
        var _a;
        return !!((_a = this.getPayload(CoreConfig.moduleName).value) === null || _a === void 0 ? void 0 : _a.disable_auto_init);
    }
    getPayload(moduleName) {
        return this.cacheDataSource.getCache(moduleName, {}).data;
    }
    updatePayload(moduleName, value) {
        const obs = this.cacheDataSource.updateCache(moduleName, value);
        PayloadRepository_1.onUpdate(moduleName, value);
        return obs;
    }
};
PayloadRepository = PayloadRepository_1 = __decorate([
    injectable({ type: 'singleton' }),
    __param(0, inject(ICacheDataSourceType)),
    __metadata("design:paramtypes", [Object])
], PayloadRepository);
export { PayloadRepository };
